// utils/medicationList.js

// Expanded medication list for IntakeForm matching
// Note: brandName and genericName are capitalized for display.
// All aliases are lowercase to simplify case-insensitive matching.
// You can programmatically generate lowercase versions or add more miss-spellings as needed.
// ---------------------------------------------------------------
export const medications = [
  // ------------------ Psychiatric & Neurologic ------------------
  {
    brandName: "Xanax",
    genericName: "Alprazolam",
    type: "Anxiety",
    aliases: ["xanax", "zanax", "zanex", "xanex", "alprazolam"],
  },
  {
    brandName: "Klonopin",
    genericName: "Clonazepam",
    type: "Anxiety",
    aliases: ["klonopin", "klonapin", "clonazepam"],
  },
  {
    brandName: "Ativan",
    genericName: "Lorazepam",
    type: "Anxiety",
    aliases: ["ativan", "atavan", "lorazepam"],
  },
  {
    brandName: "Valium",
    genericName: "Diazepam",
    type: "Anxiety",
    aliases: ["valium", "valum", "diazepam"],
  },
  {
    brandName: "Librium",
    genericName: "Chlordiazepoxide",
    type: "Anxiety",
    aliases: ["librium", "librium", "chlordiazepoxide"],
  },
  {
    brandName: "Buspar",
    genericName: "Buspirone",
    type: "Anxiety",
    aliases: ["buspar", "buspirone", "busphar"],
  },
  {
    brandName: "Vistaril",
    genericName: "Hydroxyzine",
    type: "Anxiety",
    aliases: ["vistaril", "vistril", "hydroxyzine"],
  },
  {
    brandName: "Propranolol",
    genericName: "Propranolol",
    type: "Blood Pressure / Anxiety",
    aliases: ["propranolol", "propanolol"],
  },

  {
    brandName: "Zoloft",
    genericName: "Sertraline",
    type: "Antidepressant",
    aliases: ["zoloft", "zolof", "sertraline"],
  },
  {
    brandName: "Prozac",
    genericName: "Fluoxetine",
    type: "Antidepressant",
    aliases: ["prozac", "prosac", "fluoxetine"],
  },
  {
    brandName: "Lexapro",
    genericName: "Escitalopram",
    type: "Antidepressant",
    aliases: ["lexapro", "lexapro", "escitalopram", "lexipro"],
  },
  {
    brandName: "Celexa",
    genericName: "Citalopram",
    type: "Antidepressant",
    aliases: ["celexa", "celexa", "citalopram"],
  },
  {
    brandName: "Paxil",
    genericName: "Paroxetine",
    type: "Antidepressant",
    aliases: ["paxil", "paroxetine", "paroxitine"],
  },
  {
    brandName: "Viibryd",
    genericName: "Vilazodone",
    type: "Antidepressant",
    aliases: ["viibryd", "vilazodone", "vibryd"],
  },
  {
    brandName: "Trintellix",
    genericName: "Vortioxetine",
    type: "Antidepressant",
    aliases: ["trintellix", "vortioxetine", "brintellix"],
  },
  {
    brandName: "Cymbalta",
    genericName: "Duloxetine",
    type: "Antidepressant",
    aliases: ["cymbalta", "duloxetine", "symbalta"],
  },
  {
    brandName: "Effexor",
    genericName: "Venlafaxine",
    type: "Antidepressant",
    aliases: ["effexor", "venlafaxine", "efexor"],
  },
  {
    brandName: "Pristiq",
    genericName: "Desvenlafaxine",
    type: "Antidepressant",
    aliases: ["pristiq", "desvenlafaxine", "pristique"],
  },
  {
    brandName: "Fetzima",
    genericName: "Levomilnacipran",
    type: "Antidepressant",
    aliases: ["fetzima", "levomilnacipran"],
  },
  {
    brandName: "Luvox",
    genericName: "Fluvoxamine",
    type: "Antidepressant",
    aliases: ["luvox", "fluvoxamine"],
  },
  {
    brandName: "Remeron",
    genericName: "Mirtazapine",
    type: "Antidepressant",
    aliases: ["remeron", "mirtazapine", "remron"],
  },
  {
    brandName: "Wellbutrin",
    genericName: "Bupropion",
    type: "Antidepressant",
    aliases: ["wellbutrin", "bupropion", "welbutrin"],
  },

  {
    brandName: "Trazodone",
    genericName: "Trazodone",
    type: "Sleep Aid",
    aliases: ["trazodone", "trazadone"],
  },
  {
    brandName: "Ambien",
    genericName: "Zolpidem",
    type: "Sleep Aid",
    aliases: ["ambien", "zolpidem", "ambian"],
  },
  {
    brandName: "Lunesta",
    genericName: "Eszopiclone",
    type: "Sleep Aid",
    aliases: ["lunesta", "eszopiclone", "lunesta"],
  },
  {
    brandName: "Sonata",
    genericName: "Zaleplon",
    type: "Sleep Aid",
    aliases: ["sonata", "zaleplon"],
  },
  {
    brandName: "Belsomra",
    genericName: "Suvorexant",
    type: "Sleep Aid",
    aliases: ["belsomra", "suvorexant"],
  },
  {
    brandName: "Rozerem",
    genericName: "Ramelteon",
    type: "Sleep Aid",
    aliases: ["rozerem", "ramelteon"],
  },
  {
    brandName: "Silenor",
    genericName: "Doxepin",
    type: "Sleep Aid",
    aliases: ["silenor", "doxepin"],
  },

  {
    brandName: "Adderall",
    genericName: "Amphetamine / Dextroamphetamine",
    type: "ADHD",
    aliases: ["adderall", "amphetamine", "aderall"],
  },
  {
    brandName: "Vyvanse",
    genericName: "Lisdexamfetamine",
    type: "ADHD",
    aliases: ["vyvanse", "lisdexamfetamine", "vivanse"],
  },
  {
    brandName: "Ritalin",
    genericName: "Methylphenidate",
    type: "ADHD",
    aliases: ["ritalin", "methylphenidate", "ritlin"],
  },
  {
    brandName: "Concerta",
    genericName: "Methylphenidate",
    type: "ADHD",
    aliases: ["concerta", "concertta", "methylphenidate"],
  },
  {
    brandName: "Focalin",
    genericName: "Dexmethylphenidate",
    type: "ADHD",
    aliases: ["focalin", "dexmethylphenidate"],
  },
  {
    brandName: "Dexedrine",
    genericName: "Dextroamphetamine",
    type: "ADHD",
    aliases: ["dexedrine", "dextroamphetamine"],
  },
  {
    brandName: "Strattera",
    genericName: "Atomoxetine",
    type: "ADHD",
    aliases: ["strattera", "atomoxetine", "stratera"],
  },
  {
    brandName: "Intuniv",
    genericName: "Guanfacine",
    type: "ADHD",
    aliases: ["intuniv", "guanfacine"],
  },
  {
    brandName: "Qelbree",
    genericName: "Viloxazine",
    type: "ADHD",
    aliases: ["qelbree", "viloxazine"],
  },

  {
    brandName: "Abilify",
    genericName: "Aripiprazole",
    type: "Antipsychotic",
    aliases: ["abilify", "aripiprazole", "abilifi"],
  },
  {
    brandName: "Seroquel",
    genericName: "Quetiapine",
    type: "Antipsychotic",
    aliases: ["seroquel", "quetiapine", "serequil"],
  },
  {
    brandName: "Zyprexa",
    genericName: "Olanzapine",
    type: "Antipsychotic",
    aliases: ["zyprexa", "olanzapine", "zyprexia"],
  },
  {
    brandName: "Geodon",
    genericName: "Ziprasidone",
    type: "Antipsychotic",
    aliases: ["geodon", "ziprasidone", "geodone"],
  },
  {
    brandName: "Risperdal",
    genericName: "Risperidone",
    type: "Antipsychotic",
    aliases: ["risperdal", "risperidone", "risperdol"],
  },
  {
    brandName: "Invega",
    genericName: "Paliperidone",
    type: "Antipsychotic",
    aliases: ["invega", "paliperidone"],
  },
  {
    brandName: "Clozaril",
    genericName: "Clozapine",
    type: "Antipsychotic",
    aliases: ["clozaril", "clozapine"],
  },
  {
    brandName: "Haldol",
    genericName: "Haloperidol",
    type: "Antipsychotic",
    aliases: ["haldol", "haloperidol"],
  },
  {
    brandName: "Latuda",
    genericName: "Lurasidone",
    type: "Antipsychotic",
    aliases: ["latuda", "lurasidone"],
  },
  {
    brandName: "Rexulti",
    genericName: "Brexpiprazole",
    type: "Antipsychotic",
    aliases: ["rexulti", "brexpiprazole"],
  },
  {
    brandName: "Caplyta",
    genericName: "Lumateperone",
    type: "Antipsychotic",
    aliases: ["caplyta", "lumateperone"],
  },
  {
    brandName: "Fanapt",
    genericName: "Iloperidone",
    type: "Antipsychotic",
    aliases: ["fanapt", "iloperidone"],
  },

  {
    brandName: "Lamictal",
    genericName: "Lamotrigine",
    type: "Mood Stabilizer",
    aliases: ["lamictal", "lamotrigine", "lamictil"],
  },
  {
    brandName: "Depakote",
    genericName: "Valproic Acid",
    type: "Mood Stabilizer",
    aliases: ["depakote", "valproic acid", "depacote"],
  },
  {
    brandName: "Lithium",
    genericName: "Lithium",
    type: "Mood Stabilizer",
    aliases: ["lithium", "litium"],
  },
  {
    brandName: "Tegretol",
    genericName: "Carbamazepine",
    type: "Mood Stabilizer",
    aliases: ["tegretol", "carbamazepine"],
  },
  {
    brandName: "Trileptal",
    genericName: "Oxcarbazepine",
    type: "Mood Stabilizer",
    aliases: ["trileptal", "oxcarbazepine"],
  },
  {
    brandName: "Topamax",
    genericName: "Topiramate",
    type: "Mood Stabilizer",
    aliases: ["topamax", "topiramate"],
  },

  {
    brandName: "Gabapentin/Neurontin",
    genericName: "Gabapentin",
    type: "Nerve Pain / Anticonvulsant",
    aliases: ["gabapentin", "neurontin"],
  },
  {
    brandName: "Lyrica",
    genericName: "Pregabalin",
    type: "Nerve Pain / Anticonvulsant",
    aliases: ["lyrica", "pregabalin"],
  },

  // ------------------ Medication-Assisted Treatment (MAT) ------------------
  {
    brandName: "Suboxone",
    genericName: "Buprenorphine / Naloxone",
    type: "MAT",
    aliases: ["suboxone", "suboxine", "subboxone"],
  },
  {
    brandName: "Subutex",
    genericName: "Buprenorphine",
    type: "MAT",
    aliases: ["subutex", "subutext"],
  },
  {
    brandName: "Zubsolv",
    genericName: "Buprenorphine / Naloxone",
    type: "MAT",
    aliases: ["zubsolv", "zubsolve"],
  },
  {
    brandName: "Bunavail",
    genericName: "Buprenorphine / Naloxone",
    type: "MAT",
    aliases: ["bunavail", "bunaval"],
  },
  {
    brandName: "Sublocade",
    genericName: "Buprenorphine (ER injection)",
    type: "MAT",
    aliases: ["sublocade", "sublacade"],
  },
  {
    brandName: "Probuphine",
    genericName: "Buprenorphine (implant)",
    type: "MAT",
    aliases: ["probuphine", "probuphene"],
  },
  {
    brandName: "Vivitrol",
    genericName: "Naltrexone (Injection)",
    type: "MAT",
    aliases: ["vivitrol", "vivitril"],
  },
  {
    brandName: "Naltrexone",
    genericName: "Naltrexone",
    type: "MAT",
    aliases: ["naltrexone", "revia", "naltrixone"],
  },
  {
    brandName: "Methadone",
    genericName: "Methadone",
    type: "MAT",
    aliases: ["methadone", "methadon"],
  },
  {
    brandName: "Campral",
    genericName: "Acamprosate",
    type: "MAT (Alcohol)",
    aliases: ["campral", "acamprosate"],
  },
  {
    brandName: "Antabuse",
    genericName: "Disulfiram",
    type: "MAT (Alcohol)",
    aliases: ["antabuse", "disulfiram"],
  },
  {
    brandName: "Mag-Ox",
    genericName: "Magnesium Oxide",
    type: "Supplement",
    aliases: ["magnesium oxide", "mag-ox"],
  },
  {
    brandName: "Lucemyra",
    genericName: "Lofexidine",
    type: "Opioid Withdrawal",
    aliases: ["lucemyra", "lofexidine"],
  },
  {
    brandName: "Narcan",
    genericName: "Naloxone",
    type: "Overdose Reversal",
    aliases: ["narcan", "naloxone"],
  },

  // ------------------ Cardiovascular ------------------
  {
    brandName: "Entresto",
    genericName: "Sacubitril/Valsartan",
    type: "Heart Failure",
    aliases: ["entresto", "sacubitril valsartan", "sacubitril/valsartan"],
  },
  {
    brandName: "Catapres",
    genericName: "Clonidine",
    type: "Blood Pressure / ADHD",
    aliases: ["clonidine", "clonodine", "clonindine", "catapres", "kapvay"],
  },
  {
    brandName: "Losartan",
    genericName: "Losartan",
    type: "Blood Pressure",
    aliases: ["losartan", "cozaar"],
  },
  {
    brandName: "Amlodipine",
    genericName: "Amlodipine",
    type: "Blood Pressure",
    aliases: ["amlodipine", "norvasc"],
  },
  {
    brandName: "Hydrochlorothiazide",
    genericName: "Hydrochlorothiazide",
    type: "Blood Pressure",
    aliases: ["hydrochlorothiazide", "hctz", "microzide"],
  },
  {
    brandName: "Metoprolol",
    genericName: "Metoprolol",
    type: "Blood Pressure",
    aliases: ["metoprolol", "lopressor", "toprol"],
  },
  {
    brandName: "Atenolol",
    genericName: "Atenolol",
    type: "Blood Pressure",
    aliases: ["atenolol", "tenormin"],
  },

  // ------------------ Lipids ------------------
  {
    brandName: "Lipitor",
    genericName: "Atorvastatin",
    type: "Cholesterol",
    aliases: ["lipitor", "atorvastatin"],
  },
  {
    brandName: "Crestor",
    genericName: "Rosuvastatin",
    type: "Cholesterol",
    aliases: ["crestor", "rosuvastatin"],
  },
  {
    brandName: "Zocor",
    genericName: "Simvastatin",
    type: "Cholesterol",
    aliases: ["zocor", "simvastatin"],
  },
  {
    brandName: "Pravachol",
    genericName: "Pravastatin",
    type: "Cholesterol",
    aliases: ["pravachol", "pravastatin"],
  },
  {
    brandName: "Zetia",
    genericName: "Ezetimibe",
    type: "Cholesterol",
    aliases: ["zetia", "ezetimibe"],
  },

  // ------------------ Diabetes ------------------
  {
    brandName: "Glucophage",
    genericName: "Metformin",
    type: "Diabetes",
    aliases: ["glucophage", "metformin"],
  },
  {
    brandName: "Ozempic",
    genericName: "Semaglutide",
    type: "Diabetes",
    aliases: ["ozempic", "semaglutide"],
  },
  {
    brandName: "Trulicity",
    genericName: "Dulaglutide",
    type: "Diabetes",
    aliases: ["trulicity", "dulaglutide"],
  },
  {
    brandName: "Jardiance",
    genericName: "Empagliflozin",
    type: "Diabetes",
    aliases: ["jardiance", "empagliflozin"],
  },
  {
    brandName: "Farxiga",
    genericName: "Dapagliflozin",
    type: "Diabetes",
    aliases: ["farxiga", "dapagliflozin"],
  },
  {
    brandName: "Lantus",
    genericName: "Insulin Glargine",
    type: "Diabetes",
    aliases: ["lantus", "insulin glargine"],
  },
  {
    brandName: "Humalog",
    genericName: "Insulin Lispro",
    type: "Diabetes",
    aliases: ["humalog", "insulin lispro"],
  },

  // ------------------ GI / Acid Suppression ------------------
  {
    brandName: "Prilosec",
    genericName: "Omeprazole",
    type: "GI",
    aliases: ["prilosec", "omeprazole"],
  },
  {
    brandName: "Nexium",
    genericName: "Esomeprazole",
    type: "GI",
    aliases: ["nexium", "esomeprazole"],
  },
  {
    brandName: "Protonix",
    genericName: "Pantoprazole",
    type: "GI",
    aliases: ["protonix", "pantoprazole"],
  },
  {
    brandName: "Pepcid",
    genericName: "Famotidine",
    type: "GI",
    aliases: ["pepcid", "famotidine"],
  },
  {
    brandName: "Zofran",
    genericName: "Ondansetron",
    type: "GI / Antiemetic",
    aliases: ["zofran", "ondansetron"],
  },

  // ------------------ Pain / Anti-Inflammatory ------------------
  {
    brandName: "Tylenol",
    genericName: "Acetaminophen",
    type: "Pain / Fever",
    aliases: ["tylenol", "acetaminophen", "paracetamol"],
  },
  {
    brandName: "Advil",
    genericName: "Ibuprofen",
    type: "Pain / NSAID",
    aliases: ["advil", "ibuprofen", "motrin"],
  },
  {
    brandName: "Aleve",
    genericName: "Naproxen",
    type: "Pain / NSAID",
    aliases: ["aleve", "naproxen"],
  },
  {
    brandName: "Celebrex",
    genericName: "Celecoxib",
    type: "Pain / NSAID",
    aliases: ["celebrex", "celecoxib"],
  },
  {
    brandName: "Voltaren",
    genericName: "Diclofenac",
    type: "Pain / NSAID",
    aliases: ["voltaren", "diclofenac"],
  },
  {
    brandName: "Ultram",
    genericName: "Tramadol",
    type: "Pain / Opioid",
    aliases: ["ultram", "tramadol"],
  },
  {
    brandName: "Vicodin",
    genericName: "Hydrocodone / Acetaminophen",
    type: "Pain / Opioid",
    aliases: ["vicodin", "hydrocodone"],
  },
  {
    brandName: "Percocet",
    genericName: "Oxycodone / Acetaminophen",
    type: "Pain / Opioid",
    aliases: ["percocet", "percacet", "oxyacet"],
  },
  {
    brandName: "OxyContin",
    genericName: "Oxycodone",
    type: "Pain / Opioid",
    aliases: ["oxycontin", "oxycodone"],
  },
  {
    brandName: "Morphine",
    genericName: "Morphine",
    type: "Pain / Opioid",
    aliases: ["morphine"],
  },

  // ------------------ Respiratory ------------------
  {
    brandName: "ProAir",
    genericName: "Albuterol",
    type: "Asthma",
    aliases: ["proair", "albuterol", "ventolin"],
  },
  {
    brandName: "Advair",
    genericName: "Fluticasone / Salmeterol",
    type: "Asthma",
    aliases: ["advair", "fluticasone", "salmeterol"],
  },
  {
    brandName: "Symbicort",
    genericName: "Budesonide / Formoterol",
    type: "Asthma",
    aliases: ["symbicort", "budesonide", "formoterol"],
  },
  {
    brandName: "Singulair",
    genericName: "Montelukast",
    type: "Asthma / Allergy",
    aliases: ["singulair", "montelukast"],
  },
  /* ---------- 🆕 gender-affirming / TRT meds to append ---------- */
  {
    brandName: "Estrace / Climara / Vivelle-Dot",
    genericName: "Estradiol",
    type: "Estrogen Replacement / GAHT (MTF)",
    aliases: [
      "estradiol",
      "estrace",
      "climara",
      "vivelle dot",
      "estradiol valerate",
      "estradiol cypionate",
    ],
  },
  {
    brandName: "Prometrium",
    genericName: "Progesterone (Micronized)",
    type: "Progestogen / GAHT (MTF)",
    aliases: ["progesterone", "prometrium"],
  },
  {
    brandName: "Casodex",
    genericName: "Bicalutamide",
    type: "Anti-androgen (Non-steroidal)",
    aliases: ["bicalutamide", "casodex"],
  },
  {
    brandName: "Lupron",
    genericName: "Leuprolide",
    type: "GnRH Agonist / Puberty Blocker",
    aliases: ["leuprolide", "lupron", "eligard"],
  },
  {
    brandName: "Depo-Testosterone",
    genericName: "Testosterone Cypionate",
    type: "Testosterone (IM) / GAHT (FTM) / TRT",
    aliases: ["testosterone cypionate", "depo-testosterone", "cypionate"],
  },
  {
    brandName: "Delatestryl",
    genericName: "Testosterone Enanthate",
    type: "Testosterone (IM) / GAHT (FTM) / TRT",
    aliases: ["testosterone enanthate", "delatestryl", "enanthate"],
  },
  {
    brandName: "AndroGel / Testim",
    genericName: "Testosterone (Transdermal)",
    type: "Testosterone Gel / TRT",
    aliases: ["androgel", "testim", "testosterone gel"],
  },
  {
    brandName: "Pregnyl / Novarel",
    genericName: "Human Chorionic Gonadotropin (hCG)",
    type: "Gonadotropin (TRT Adjunct / Fertility)",
    aliases: ["hcg", "pregnyl", "novarel", "chorionic gonadotropin"],
  },
  {
    brandName: "Arimidex",
    genericName: "Anastrozole",
    type: "Aromatase Inhibitor (TRT Adjunct)",
    aliases: ["anastrozole", "arimidex"],
  },
  // ------------------ Misc / Other Common ------------------
  {
    brandName: "Benadryl",
    genericName: "Diphenhydramine",
    type: "Allergy",
    aliases: ["benadryl", "diphenhydramine"],
  },
  {
    brandName: "Humira",
    genericName: "Adalimumab",
    type: "Biologic / Immunosuppressant",
    aliases: ["humira", "adalimumab"],
  },
  {
    brandName: "Januvia",
    genericName: "Sitagliptin",
    type: "Diabetes (DPP-4 Inhibitor)",
    aliases: ["januvia", "sitagliptin"],
  },
  {
    brandName: "Aldactone",
    genericName: "Spironolactone",
    type: "Anti-androgen / K-sparing Diuretic",
    aliases: ["spironolactone", "aldactone", "spiro"],
  },
  {
    brandName: "Propecia / Proscar",
    genericName: "Finasteride",
    type: "5-Alpha Reductase Inhibitor",
    aliases: ["finasteride", "propecia", "proscar"],
  },
  {
    brandName: "Avodart",
    genericName: "Dutasteride",
    type: "5-Alpha Reductase Inhibitor",
    aliases: ["dutasteride", "avodart"],
  },
  {
    brandName: "Femara",
    genericName: "Letrozole",
    type: "Aromatase Inhibitor (TRT Adjunct)",
    aliases: ["letrozole", "femara"],
  },
  {
    brandName: "Aromasin",
    genericName: "Exemestane",
    type: "Aromatase Inhibitor (TRT Adjunct)",
    aliases: ["exemestane", "aromasin"],
  },
  {
    brandName: "Clomid / Serophene",
    genericName: "Clomiphene",
    type: "SERM (Fertility / TRT Adjunct)",
    aliases: ["clomiphene", "clomid", "serophene"],
  },
  {
    brandName: "Zoladex",
    genericName: "Goserelin",
    type: "GnRH Agonist / Puberty Blocker",
    aliases: ["goserelin", "zoladex"],
  },
  {
    brandName: "Trelstar",
    genericName: "Triptorelin",
    type: "GnRH Agonist / Puberty Blocker",
    aliases: ["triptorelin", "trelstar"],
  },
  {
    brandName: "Keytruda",
    genericName: "Pembrolizumab",
    type: "Immunotherapy / Cancer",
    aliases: ["keytruda", "pembrolizumab"],
  },
  {
    brandName: "Supprelin LA / Vantas",
    genericName: "Histrelin",
    type: "GnRH Agonist Implant",
    aliases: ["histrelin", "supprelin", "vantas"],
  },
  {
    brandName: "Aveed / Jatenzo",
    genericName: "Testosterone Undecanoate",
    type: "Testosterone (IM / Oral) - TRT / GAHT (FTM)",
    aliases: ["testosterone undecanoate", "aveed", "jatenzo", "undecanoate"],
  },
  {
    brandName: "Testopel",
    genericName: "Testosterone Pellets",
    type: "Testosterone (SubQ Pellets) - TRT / GAHT (FTM)",
    aliases: ["testopel", "testosterone pellet", "pellets"],
  },
  {
    brandName: "Claritin",
    genericName: "Loratadine",
    type: "Allergy",
    aliases: ["claritin", "loratadine"],
  },
  {
    brandName: "Zyrtec",
    genericName: "Cetirizine",
    type: "Allergy",
    aliases: ["zyrtec", "cetirizine"],
  },
  {
    brandName: "Flonase",
    genericName: "Fluticasone",
    type: "Allergy",
    aliases: ["flonase", "fluticasone"],
  },
  {
    brandName: "Nasacort",
    genericName: "Triamcinolone",
    type: "Nasal Steroid",
    aliases: ["nasacort", "triamcinolone"],
  },
  {
    brandName: "Prednisone",
    genericName: "Prednisone",
    type: "Corticosteroid",
    aliases: ["prednisone", "prednizone"],
  },
  {
    brandName: "Medrol",
    genericName: "Methylprednisolone",
    type: "Corticosteroid",
    aliases: ["medrol", "methylprednisolone"],
  },
  {
    brandName: "Doxycycline",
    genericName: "Doxycycline",
    type: "Antibiotic",
    aliases: ["doxycycline", "doxycline"],
  },
  {
    brandName: "Amoxicillin",
    genericName: "Amoxicillin",
    type: "Antibiotic",
    aliases: ["amoxicillin", "amoxcillin"],
  },
  {
    brandName: "Augmentin",
    genericName: "Amoxicillin / Clavulanate",
    type: "Antibiotic",
    aliases: ["augmentin", "amoxicillin clavulanate"],
  },
  {
    brandName: "Zithromax",
    genericName: "Azithromycin",
    type: "Antibiotic",
    aliases: ["zithromax", "azithromycin", "z-pack"],
  },
  {
    brandName: "Cipro",
    genericName: "Ciprofloxacin",
    type: "Antibiotic",
    aliases: ["cipro", "ciprofloxacin"],
  },
  {
    brandName: "Bactrim",
    genericName: "Sulfamethoxazole / Trimethoprim",
    type: "Antibiotic",
    aliases: ["bactrim", "smx/tmp"],
  },
  {
    brandName: "Zyloprim",
    genericName: "Allopurinol",
    type: "Xanthine-Oxidase Inhibitor / Antigout",
    aliases: ["allopurinol", "zyloprim", "aloprim"],
  },
  {
    brandName: "Cogentin",
    genericName: "Benztropine",
    type: "Anticholinergic / Antiparkinsonian",
    aliases: ["benztropine", "cogentin"],
  },
  {
    brandName: "Creon",
    genericName: "Pancrelipase",
    type: "Digestive Enzyme Replacement",
    aliases: ["pancrelipase", "creon", "zenpep", "pertzye"],
  },
  {
    brandName: "Eliquis",
    genericName: "Apixaban",
    type: "Anticoagulant (Factor Xa Inhibitor)",
    aliases: ["apixaban", "eliquis"],
  },
  {
    brandName: "Flexeril",
    genericName: "Cyclobenzaprine",
    type: "Muscle Relaxant",
    aliases: ["cyclobenzaprine", "flexeril", "fexmid", "amrix"],
  },
  {
    brandName: "Prolixin",
    genericName: "Fluphenazine",
    type: "Antipsychotic (Typical)",
    aliases: ["fluphenazine", "prolixin"],
  },
  {
    brandName: "Glucotrol",
    genericName: "Glipizide",
    type: "Sulfonylurea Antidiabetic",
    aliases: ["glipizide", "glucotrol"],
  },
  /* ---- GLP-1 receptor agonists (any GLP-1 meds) ---- */
  {
    brandName: "Victoza",
    genericName: "Liraglutide",
    type: "GLP-1 Receptor Agonist",
    aliases: ["liraglutide", "victoza", "saxenda"],
  },
  {
    brandName: "Ozempic",
    genericName: "Semaglutide",
    type: "GLP-1 Receptor Agonist",
    aliases: ["semaglutide", "ozempic", "rybelsus", "wegovy"],
  },
  {
    brandName: "Trulicity",
    genericName: "Dulaglutide",
    type: "GLP-1 Receptor Agonist",
    aliases: ["dulaglutide", "trulicity"],
  },
  {
    brandName: "Byetta",
    genericName: "Exenatide",
    type: "GLP-1 Receptor Agonist",
    aliases: ["exenatide", "byetta", "bydureon", "bydureon bcise"],
  },
  {
    brandName: "Mounjaro",
    genericName: "Tirzepatide",
    type: "Dual GIP/GLP-1 Agonist",
    aliases: ["tirzepatide", "mounjaro", "zepbound"],
  },
  {
    brandName: "Keppra",
    genericName: "Levetiracetam",
    type: "Anticonvulsant",
    aliases: ["levetiracetam", "keppra", "keppra xr", "spritam"],
  },
  {
    brandName: "Levitra",
    genericName: "Vardenafil",
    type: "ED Medication",
    aliases: ["levitra", "vardenafil"],
  },
  {
    brandName: "Lasix",
    genericName: "Furosemide",
    type: "Loop Diuretic",
    aliases: ["furosemide", "lasix"],
  },
  {
    brandName: "Imbruvica",
    genericName: "Ibrutinib",
    type: "Cancer / BTK Inhibitor",
    aliases: ["imbruvica", "ibrutinib"],
  },
  {
    brandName: "Imodium",
    genericName: "Loperamide",
    type: "Antidiarrheal",
    aliases: ["loperamide", "imodium", "diamode"],
  },
  {
    brandName: "Minipress",
    genericName: "Prazosin",
    type: "Alpha-1 Blocker / Antihypertensive",
    aliases: ["prazosin", "minipress"],
  },
  {
    brandName: "Requip",
    genericName: "Ropinirole",
    type: "Dopamine Agonist",
    aliases: ["ropinirole", "requip"],
  },
  {
    brandName: "Senexon",
    genericName: "Senna",
    type: "Stimulant Laxative",
    aliases: ["senexon", "senna", "senokot", "ex-lax", "sennosides"],
  },
  {
    brandName: "Flomax",
    genericName: "Tamsulosin",
    type: "Alpha-1 Blocker / BPH Agent",
    aliases: ["tamsulosin", "flomax"],
  },
  {
    brandName: "Synthroid",
    genericName: "Levothyroxine",
    type: "Thyroid Replacement",
    aliases: ["levothyroxine", "synthroid", "levoxyl", "eltroxin"],
  },
  {
    brandName: "Coreg",
    genericName: "Carvedilol",
    type: "Blood Pressure / Heart Failure",
    aliases: ["carvedilol", "coreg"],
  },
  {
    brandName: "Aldactone",
    genericName: "Spironolactone",
    type: "Potassium-Sparing Diuretic",
    aliases: ["spironolactone", "aldactone"],
  },
  {
    brandName: "Coumadin",
    genericName: "Warfarin",
    type: "Anticoagulant (Vitamin K Antagonist)",
    aliases: ["warfarin", "coumadin", "jantoven"],
  },
  {
    brandName: "Prevnar",
    genericName: "Pneumococcal Vaccine",
    type: "Vaccine",
    aliases: ["prevnar", "pneumococcal vaccine", "pneumovax"],
  },
  {
    brandName: "Prinivil",
    genericName: "Lisinopril",
    type: "ACE Inhibitor (Antihypertensive)",
    aliases: ["lisinopril", "prinivil", "zestril"],
  },

  {
    brandName: "Plavix",
    genericName: "Clopidogrel",
    type: "Antiplatelet",
    aliases: ["clopidogrel", "plavix"],
  },
  {
    brandName: "Xarelto",
    genericName: "Rivaroxaban",
    type: "Anticoagulant (Factor Xa Inhibitor)",
    aliases: ["rivaroxaban", "xarelto"],
  },
  {
    brandName: "Mobic",
    genericName: "Meloxicam",
    type: "Pain / NSAID",
    aliases: ["meloxicam", "mobic"],
  },
  {
    brandName: "Cardizem",
    genericName: "Diltiazem",
    type: "Calcium-Channel Blocker / Rate Control",
    aliases: ["diltiazem", "cardizem", "tiazac"],
  },
  {
    brandName: "Lanoxin",
    genericName: "Digoxin",
    type: "Inotrope / Rate Control",
    aliases: ["digoxin", "lanoxin"],
  },
  {
    brandName: "Zanaflex",
    genericName: "Tizanidine",
    type: "Muscle Relaxant",
    aliases: ["tizanidine", "zanaflex"],
  },
  {
    brandName: "Baclofen",
    genericName: "Baclofen",
    type: "Muscle Relaxant / Antispastic",
    aliases: ["baclofen", "lioresal", "gablofen"],
  },
  {
    brandName: "Robaxin",
    genericName: "Methocarbamol",
    type: "Muscle Relaxant",
    aliases: ["methocarbamol", "robaxin"],
  },
  {
    brandName: "Keflex",
    genericName: "Cephalexin",
    type: "Antibiotic (Cephalosporin)",
    aliases: ["cephalexin", "keflex"],
  },
  {
    brandName: "Flagyl",
    genericName: "Metronidazole",
    type: "Antibiotic / Antiprotozoal",
    aliases: ["metronidazole", "flagyl"],
  },
  {
    brandName: "Macrobid",
    genericName: "Nitrofurantoin",
    type: "Antibiotic (UTI)",
    aliases: ["nitrofurantoin", "macrobid", "macrodantin"],
  },
  {
    brandName: "Levaquin",
    genericName: "Levofloxacin",
    type: "Antibiotic (Fluoroquinolone)",
    aliases: ["levofloxacin", "levaquin"],
  },
  {
    brandName: "Chantix",
    genericName: "Varenicline",
    type: "Smoking Cessation",
    aliases: ["varenicline", "chantix"],
  },
  {
    brandName: "Miralax",
    genericName: "Polyethylene Glycol 3350",
    type: "Osmotic Laxative",
    aliases: ["polyethylene glycol", "miralax", "peg 3350"],
  },
  {
    brandName: "Colace",
    genericName: "Docusate",
    type: "Stool Softener",
    aliases: ["docusate", "colace"],
  },
  {
    brandName: "Spiriva",
    genericName: "Tiotropium",
    type: "COPD / Bronchodilator",
    aliases: ["tiotropium", "spiriva"],
  },
  {
    brandName: "Invokana",
    genericName: "Canagliflozin",
    type: "SGLT-2 Antidiabetic",
    aliases: ["canagliflozin", "invokana"],
  },
  {
    brandName: "Cialis",
    genericName: "Tadalafil",
    type: "ED Medication",
    aliases: ["cialis", "tadalafil", "adcirca"],
  },
  {
    brandName: "Viagra",
    genericName: "Sildenafil",
    type: "ED Medication",
    aliases: ["viagra", "sildenafil", "revatio"],
  },
  {
    brandName: "Brilinta",
    genericName: "Ticagrelor",
    type: "Antiplatelet",
    aliases: ["brilinta", "ticagrelor"],
  },
  {
    brandName: "Revlimid",
    genericName: "Lenalidomide",
    type: "Cancer / Immunomodulator",
    aliases: ["revlimid", "lenalidomide"],
  },
  {
    brandName: "Ibrance",
    genericName: "Palbociclib",
    type: "Cancer / CDK Inhibitor",
    aliases: ["ibrance", "palbociclib"],
  },
  {
    brandName: "Tecfidera",
    genericName: "Dimethyl Fumarate",
    type: "Multiple Sclerosis",
    aliases: ["tecfidera", "dimethyl fumarate"],
  },
  {
    brandName: "Otezla",
    genericName: "Apremilast",
    type: "PDE4 Inhibitor / Psoriasis",
    aliases: ["otezla", "apremilast"],
  },
  {
    brandName: "Linzess",
    genericName: "Linaclotide",
    type: "IBS-C / Constipation",
    aliases: ["linzess", "linaclotide"],
  },
  {
    brandName: "Nuvaring",
    genericName: "Etonogestrel/Ethinyl Estradiol",
    type: "Contraceptive",
    aliases: ["nuvaring", "etonogestrel", "ethinyl estradiol"],
  },
  {
    brandName: "Mirena",
    genericName: "Levonorgestrel IUD",
    type: "Contraceptive",
    aliases: ["mirena", "levonorgestrel iud", "kyleena", "liletta", "skyla"],
  },
  {
    brandName: "Mavyret",
    genericName: "Glecaprevir/Pibrentasvir",
    type: "Hepatitis C",
    aliases: ["mavyret", "glecaprevir", "pibrentasvir"],
  },
  {
    brandName: "Dupixent",
    genericName: "Dupilumab",
    type: "Biologic / Immunomodulator",
    aliases: ["dupixent", "dupilumab"],
  },
  {
    brandName: "Stelara",
    genericName: "Ustekinumab",
    type: "Biologic / Immunomodulator",
    aliases: ["stelara", "ustekinumab"],
  },
  {
    brandName: "Cosentyx",
    genericName: "Secukinumab",
    type: "Biologic / Immunomodulator",
    aliases: ["cosentyx", "secukinumab"],
  },
  {
    brandName: "Skyrizi",
    genericName: "Risankizumab",
    type: "Biologic / Immunomodulator",
    aliases: ["skyrizi", "risankizumab"],
  },
  {
    brandName: "Tremfya",
    genericName: "Guselkumab",
    type: "Biologic / Immunomodulator",
    aliases: ["tremfya", "guselkumab"],
  },
  {
    brandName: "Entyvio",
    genericName: "Vedolizumab",
    type: "Biologic / IBD Treatment",
    aliases: ["entyvio", "vedolizumab"],
  },
  {
    brandName: "Taltz",
    genericName: "Ixekizumab",
    type: "Biologic / Immunomodulator",
    aliases: ["taltz", "ixekizumab"],
  },
  {
    brandName: "Prolia",
    genericName: "Denosumab",
    type: "Osteoporosis",
    aliases: ["prolia", "denosumab", "xgeva"],
  },
  {
    brandName: "Xolair",
    genericName: "Omalizumab",
    type: "Biologic / Asthma & Urticaria",
    aliases: ["xolair", "omalizumab"],
  },
  {
    brandName: "Botox",
    genericName: "OnabotulinumtoxinA",
    type: "Neurotoxin / Cosmetic",
    aliases: ["botox", "onabotulinumtoxina"],
  },
  {
    brandName: "Rinvoq",
    genericName: "Upadacitinib",
    type: "JAK Inhibitor",
    aliases: ["rinvoq", "upadacitinib"],
  },
  {
    brandName: "Epclusa",
    genericName: "Sofosbuvir/Velpatasvir",
    type: "Hepatitis C",
    aliases: ["epclusa", "sofosbuvir", "velpatasvir"],
  },
  {
    brandName: "Vraylar",
    genericName: "Cariprazine",
    type: "Atypical Antipsychotic",
    aliases: ["vraylar", "cariprazine"],
  },
  {
    brandName: "Aubagio",
    genericName: "Teriflunomide",
    type: "Multiple Sclerosis",
    aliases: ["aubagio", "teriflunomide"],
  },
  {
    brandName: "Gilenya",
    genericName: "Fingolimod",
    type: "Multiple Sclerosis",
    aliases: ["gilenya", "fingolimod"],
  },
  {
    brandName: "Xeljanz",
    genericName: "Tofacitinib",
    type: "JAK Inhibitor",
    aliases: ["xeljanz", "tofacitinib"],
  },
  {
    brandName: "Ocrevus",
    genericName: "Ocrelizumab",
    type: "Multiple Sclerosis",
    aliases: ["ocrevus", "ocrelizumab"],
  },
  {
    brandName: "Nuedexta",
    genericName: "Dextromethorphan/Quinidine",
    type: "PBA Treatment",
    aliases: ["nuedexta", "dextromethorphan", "quinidine"],
  },
  {
    brandName: "Evrysdi",
    genericName: "Risdiplam",
    type: "Spinal Muscular Atrophy",
    aliases: ["evrysdi", "risdiplam"],
  },
  {
    brandName: "Trikafta",
    genericName: "Elexacaftor/Tezacaftor/Ivacaftor",
    type: "Cystic Fibrosis",
    aliases: ["trikafta", "elexacaftor", "tezacaftor", "ivacaftor"],
  },
  {
    brandName: "Ingrezza",
    genericName: "Valbenazine",
    type: "VMAT2 Inhibitor / Tardive Dyskinesia",
    aliases: ["ingrezza", "valbenazine"],
  },
  {
    brandName: "Austedo",
    genericName: "Deutetrabenazine",
    type: "VMAT2 Inhibitor / Chorea",
    aliases: ["austedo", "deutetrabenazine"],
  },
  {
    brandName: "Enbrel",
    genericName: "Etanercept",
    type: "Biologic / TNF Inhibitor",
    aliases: ["enbrel", "etanercept"],
  },
  {
    brandName: "Shingrix",
    genericName: "Zoster Vaccine Recombinant",
    type: "Vaccine",
    aliases: ["shingrix", "zoster vaccine"],
  },
  {
    brandName: "Imdur",
    genericName: "Isosorbide Mononitrate",
    type: "Anti-anginal Nitrate",
    aliases: ["isosorbide mononitrate", "imdur"],
  },
];

export const findMedicationSuggestions = (input) => {
  if (!input) return [];

  const search = input.toLowerCase().trim();
  const directHits = [];

  /* ---------- 1. direct substring hits (fast) ---------- */
  medications.forEach((m) => {
    if (
      m.brandName.toLowerCase().includes(search) ||
      m.genericName.toLowerCase().includes(search) ||
      m.aliases.some((a) => a.includes(search))
    ) {
      directHits.push(m);
    }
  });

  if (directHits.length) return directHits.slice(0, 5);

  /* ---------- 2. fuzzy fallback (Levenshtein) ---------- */
  const fuzzy = [];

  medications.forEach((m) => {
    const brandScore = calculateSimilarity(search, m.brandName.toLowerCase());
    const genericScore = calculateSimilarity(
      search,
      m.genericName.toLowerCase()
    );
    const aliasScore = Math.max(
      ...m.aliases.map((a) => calculateSimilarity(search, a))
    );

    const bestScore = Math.max(brandScore, genericScore, aliasScore);

    if (bestScore > 0.5) {
      // ←- lowered from 0.6
      fuzzy.push({ ...m, score: bestScore });
    }
  });

  /* highest-score first */
  fuzzy.sort((a, b) => b.score - a.score);

  return fuzzy.slice(0, 5);
};

// Helper function to calculate string similarity (Levenshtein distance)
const calculateSimilarity = (str1, str2) => {
  const len1 = str1.length;
  const len2 = str2.length;
  const matrix = [];

  for (let i = 0; i <= len1; i++) {
    matrix[i] = [i];
  }

  for (let j = 0; j <= len2; j++) {
    matrix[0][j] = j;
  }

  for (let i = 1; i <= len1; i++) {
    for (let j = 1; j <= len2; j++) {
      if (str1[i - 1] === str2[j - 1]) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j] + 1
        );
      }
    }
  }

  const maxLen = Math.max(len1, len2);
  return maxLen === 0 ? 1 : 1 - matrix[len1][len2] / maxLen;
};
